<template>
	<div class="d-flex flex-column overflow-auto">
		<DialogBody>
			<ToggleButton
				:model-value="acceptNews"
				@update:model-value="changeNewsPreferences"
				:title="$t('communicationPreferences_dealsNews')"
			/>
		</DialogBody>
	</div>
</template>
<script setup lang="ts">
	import { ref } from 'vue'
	import { useProfileStore } from '~/store/profile'
	import { storeToRefs } from 'pinia'
	import CommunicationPreferencesAction from '~/actions/communicationPreferences/action'

	const profileStore = useProfileStore()
	const { profile } = storeToRefs(profileStore)
	const acceptNews = ref<boolean>(profile.value?.consentCommercialCommunications || false)

	const changeNewsPreferences = () => {
		if (!profile.value?.id) return
		acceptNews.value = !acceptNews.value
		CommunicationPreferencesAction.changeNewsPreferences(profile.value?.id, acceptNews.value)
	}
</script>
